import React from "react";
import PublicHeader from "../../components/headers/publicHeader/PublicHeader";
import Footer from "../../components/common/footer/Footer";

const PublicLayout = ({ children }) => (
  /* The Public Layout is used for the public home page of the website, as well as for the Privacy Policy page and the Contact page. It uses the public header, which only has a logo and a sign in button, and the standard website footer. The actual page is passed as children. */

  <div>
    <PublicHeader />
    {children}
    <Footer isLoggedIn={false} />
  </div>
);

export default PublicLayout;
